import React from 'react';
export const Footer = () => {
  const scrollToSection = (id: string) => {
    const element = document.getElementById(id);
    if (element) {
      element.scrollIntoView({
        behavior: 'smooth'
      });
    }
  };
  return <footer className="w-full py-12 sm:py-16 border-t border-[#6366F1]/20 bg-gradient-to-b from-transparent to-[#020311]/50 mt-16" data-id="element-79">
      <div className="max-w-6xl mx-auto px-4" data-id="element-80">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-12 items-start" data-id="element-81">
          <div className="flex flex-col items-start col-span-1 sm:col-span-2 lg:col-span-1" data-id="element-82">
            <img src="https://cdn.magicpatterns.com/uploads/pPv8sZAUYxABkDBucNAnxU/esa.png" alt="EquipSales Logo" className="h-12 sm:h-14 md:h-16 mb-6" data-id="element-83" />
            <p className="text-[#F5F5F7]/70 text-sm sm:text-base max-w-xs" data-id="element-84">
              The $100M Sales Team Operating System
              <br data-id="element-85" />
              for 7-8 figure sales organizations
            </p>
          </div>
          <div className="flex flex-col items-start" data-id="element-86">
            <h3 className="text-[#F5F5F7] font-semibold mb-4 text-base sm:text-lg" data-id="element-87">
              Navigate
            </h3>
            <ul className="flex flex-col gap-3" data-id="element-88">
              <li data-id="element-89">
                <button onClick={() => scrollToSection('headline')} className="text-[#F5F5F7]/70 hover:text-[#7C3AED] transition-colors text-sm sm:text-base" data-id="element-90">
                  Home
                </button>
              </li>
              <li data-id="element-91">
                <button onClick={() => scrollToSection('what-we-do')} className="text-[#F5F5F7]/70 hover:text-[#7C3AED] transition-colors text-sm sm:text-base" data-id="element-92">
                  What We Do
                </button>
              </li>
              <li data-id="element-93">
                <button onClick={() => scrollToSection('who-this-is-for')} className="text-[#F5F5F7]/70 hover:text-[#7C3AED] transition-colors text-sm sm:text-base" data-id="element-94">
                  Who This Is For
                </button>
              </li>
              <li data-id="element-95">
                <button onClick={() => scrollToSection('faq')} className="text-[#F5F5F7]/70 hover:text-[#7C3AED] transition-colors text-sm sm:text-base" data-id="element-96">
                  FAQ
                </button>
              </li>
            </ul>
          </div>

          <div className="flex flex-col items-start" data-id="element-97">
            <h3 className="text-[#F5F5F7] font-semibold mb-4 text-base sm:text-lg" data-id="element-98">
              Legal
            </h3>
            <ul className="flex flex-col gap-3" data-id="element-99">
              <li data-id="element-100">
                <a href="/privacypolicy" className="text-[#F5F5F7]/70 hover:text-[#7C3AED] transition-colors text-sm sm:text-base" data-id="element-101">
                  Privacy Policy
                </a>
              </li>
              <li data-id="element-102">
                <a href="/terms" className="text-[#F5F5F7]/70 hover:text-[#7C3AED] transition-colors text-sm sm:text-base" data-id="element-103">
                  Terms & Conditions
                </a>
              </li>
            </ul>
          </div>
        </div>
        <div className="mt-10 sm:mt-12 pt-6 sm:pt-8 border-t border-[#6366F1]/20 text-center" data-id="element-104">
          <p className="text-[#F5F5F7]/50 text-xs sm:text-sm" data-id="element-105">
            © {new Date().getFullYear()} Equip Sales Academy. All rights
            reserved.
          </p>
        </div>
      </div>
    </footer>;
};